import { heroBeats } from '@/mocks/wedding';

/* The film. Exactly one screen tall, runs on its own clock, never scroll-driven. */
const VIDEO =
  'https://static.readdy.ai/video/27c20178bc0bf6acf0525db33140ef99/619cd2a3dadd6920b314709f291777d5.mp4';
const COVER =
  'https://static.readdy.ai/image/cc733f6f6e0d1f78a0bfb68c2c846ad3/750cb8afdd06f0a6e2e07c0a03424542.jpeg';

export default function Chapter() {
  return (
    <section
      className="chapter"
      id="top"
      data-video={VIDEO}
      data-duration="14"
      data-poster={COVER}
      data-label="초대"
    >
      <div className="stage">
        <img
          className="plate"
          src={COVER}
          width="1920"
          height="1080"
          fetchPriority="high"
          decoding="async"
          alt="나무 테이블 위에 겹쳐 놓인 웨딩 사진들, 그중 한 장이 빛을 받아 앞으로 떠오르는 장면"
        />
        <div className="veil" aria-hidden="true" />

        {/* Beat 1 — acts 1+2+3 merged (0–9s of 14s): the invitation and the promise. */}
        <div
          className="beat"
          data-from="0"
          data-to="0.6429"
          data-pos="left"
          data-depth="soft"
          data-tone="dark"
          data-motion="track"
          id="overview"
        >
          <p className="stamp">{heroBeats.beat1.stamp}</p>
          <h2 data-split="lines">
            우리의 가장 빛나는 날에
            <br />
            당신을 <em className="accent">모십니다</em>
          </h2>
          <p className="sub">{heroBeats.beat1.sub}</p>
          <ul className="chips" data-side="right">
            {heroBeats.chips.map((c) => (
              <li key={c}>{c}</li>
            ))}
          </ul>
        </div>

        {/* Beat 2 — act 4 (9–14s): the invitation details. */}
        <div
          className="beat"
          data-from="0.6429"
          data-to="1"
          data-pos="left"
          data-depth="soft"
          data-tone="dark"
          data-motion="rise"
          id="invite"
        >
          <p className="stamp">{heroBeats.beat2.stamp}</p>
          <h2 data-split="lines">
            2026년 5월 16일,
            <br />
            봄 <em className="accent">한가운데서</em>
          </h2>
          <p className="sub">{heroBeats.beat2.sub}</p>
          <a className="cta" href="#ceremony">
            예식 정보 보기
          </a>
        </div>

        <div className="scroll-cue" aria-hidden="true">
          <span />
        </div>
      </div>
    </section>
  );
}